"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = default_1;
const getExistingReleaseBranch_1 = __importDefault(require("../release/getExistingReleaseBranch"));
const releaseUtils_1 = __importDefault(require("../release/releaseUtils"));
function default_1(execSync, prompt) {
    execSync('git fetch -p', { stdio: 'inherit' });
    const mainBranch = releaseUtils_1.default.getMainBranchName(execSync);
    let branchToMerge;
    try {
        branchToMerge = (0, getExistingReleaseBranch_1.default)(execSync, prompt);
    }
    catch (e) {
        console.log('There is no release/hotfix branch to merge!');
        process.exit(1);
    }
    let semver;
    try {
        semver = branchToMerge.match(/\d+\.\d+\.\d+/)[0];
    }
    catch (e) {
        console.log('Invalid release number. Please proceed manually.');
        process.exit(1);
    }
    const answer = prompt(`
  Gearing up to merge n tag "${branchToMerge}". Ok to proceed?

  Type 'yes' or 'no': `);
    if (answer !== 'yes') {
        console.log("Quitting! Come back when you're ready!");
        process.exit(1);
    }
    console.log(`Merging "${branchToMerge}" into develop...`);
    execSync('git checkout develop');
    execSync('git pull');
    execSync(`git merge --no-ff origin/${branchToMerge}`);
    execSync('git push origin develop');
    console.log('...done!');
    console.log(`Merging "${branchToMerge}" into ${mainBranch}...`);
    execSync(`git checkout ${mainBranch}`);
    execSync('git pull');
    execSync(`git merge --no-ff origin/${branchToMerge}`);
    execSync(`git push origin ${mainBranch}`);
    console.log('...done!');
    console.log(`Creating tag "${semver}"...`);
    execSync(`git tag ${semver}`);
    execSync(`git push origin ${semver}`);
    console.log('...done!');
    console.log(`Killing "${branchToMerge}"...`);
    execSync(`git push origin :${branchToMerge}`);
    console.log('...killed X-o');
    console.log("Consider yourself merged 'n tagged");
}
